import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import { CloseBig } from "@tiny/icons";

type BranchOption = "yes" | "no" | "both";

interface DeleteBranchDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (option: BranchOption) => void;
}

function DeleteBranchDialog({
  open,
  onCancel,
  onConfirm,
}: DeleteBranchDialogProps) {
  const [selected, setSelected] = React.useState<BranchOption>("both");

  const handleConfirm = () => {
    onConfirm(selected);
    setSelected("both");
  };

  const handleCancel = () => {
    setSelected("both");
    onCancel();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 0,
            m: 0,
          }}
        >
          <Typography variant="h3">Delete conditional split</Typography>
          <IconButton onClick={handleCancel}>
            <CloseBig />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="inherit" color="grey">
          Which branch would you like to delete?
        </Typography>
        <RadioGroup
          value={selected}
          onChange={(e) => setSelected(e.target.value as BranchOption)}
          sx={{ mt: 3 }}
        >
          <FormControlLabel
            value="yes"
            control={<Radio />}
            label="Delete Yes branch"
          />
          <FormControlLabel
            value="no"
            control={<Radio />}
            label="Delete No branch"
          />
          <FormControlLabel
            value="both"
            control={<Radio />}
            label="Delete both branches"
          />
        </RadioGroup>
        <Divider sx={{ mt: 4 }} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export type { BranchOption };
export default DeleteBranchDialog;
